export default "__VITE_PUBLIC_ASSET__b1413c33__"